import type { Territoire, TerritoireAvecPerimetres } from "models";
import { collectivitesApiClient } from "./apiClients";
import { Endpoints } from "enums";

/**
 * Récupère tous les territoires
 * @returns tous les Territoires
 */
async function getAll(): Promise<Array<Territoire>> {
  const url = Endpoints.TERRITOIRES;
  return collectivitesApiClient.get(url);
}

/**
 * Récupère un territoire en fonction de son id
 * @param id id du territoire
 * @returns un Territoire
 */
async function getById(id: string): Promise<Territoire> {
  const url = `/${Endpoints.TERRITOIRES}/${id}`;
  return collectivitesApiClient.get(url);
}

/**
 * Récupère tous les territoires et leurs relations avec les périmètres
 */
async function getTerritoiresEtPerimetres(): Promise<Array<TerritoireAvecPerimetres>> {
  const url = Endpoints.TERRITOIRES_AVEC_PERIMETRES;
  return collectivitesApiClient.get(url);
}

export const territoiresService = {
  getById,
  getAll,
  getTerritoiresEtPerimetres,
};
